import api from './api'
import axios from 'axios'

// 创建用于文件上传的axios实例
const fileApi = axios.create({
  baseURL: api.defaults.baseURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

// 添加请求拦截器以包含token
fileApi.interceptors.request.use(config => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
})

// 添加响应拦截器以统一处理响应格式
fileApi.interceptors.response.use(
  (response) => {
    // 如果是blob类型，直接返回（用于文件下载）
    if (response.config && response.config.responseType === 'blob') {
      return response
    }
    // 统一处理响应数据
    if (response.data && response.data.success !== undefined) {
      return response.data
    }
    return response
  },
  (error) => {
    // 统一错误处理
    if (error.response) {
      const { status, data } = error.response
      
      switch (status) {
        case 401:
          localStorage.removeItem('user')
          if (window.confirm('登录已过期，请重新登录')) {
            window.location.href = '/'
          } else {
            window.location.href = '/'
          }
          break
        case 403:
          console.error('访问被拒绝')
          break
        case 404:
          console.error('资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error('请求失败:', data?.message || error.message)
      }
    } else if (error.request) {
      console.error('网络错误，请检查网络连接')
    } else {
      console.error('请求配置错误:', error.message)
    }
    
    return Promise.reject(error)
  }
)

export const enrollmentService = {
  // OCR识别身份证
  recognizeIdCard(file) {
    const formData = new FormData()
    formData.append('file', file)
    return fileApi.post('/enrollments/idcard/ocr', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  submitEnrollment(payload) {
    return api.post('/enrollments', payload)
  },

  fetchMyEnrollments(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10 } = params
    query.append('page', page)
    query.append('size', size)
    return api.get(`/enrollments/my?${query.toString()}`)
  },

  fetchEnrollments(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10, courseId, status, keyword } = params
    query.append('page', page)
    query.append('size', size)
    if (courseId) query.append('courseId', courseId)
    if (status) query.append('status', status)
    if (keyword) query.append('keyword', keyword)
    return api.get(`/enrollments?${query.toString()}`)
  },

  reviewEnrollment(id, payload) {
    return api.post(`/enrollments/${id}/decision`, payload)
  },

  fetchEnrollmentDetail(id) {
    return api.get(`/enrollments/${id}`)
  },

  updateEnrollmentStatus(id, payload) {
    return api.put(`/enrollments/${id}/status`, payload)
  },

  transferEnrollment(id, payload) {
    return api.post(`/enrollments/${id}/transfer`, payload)
  },

  refundEnrollment(id, file, noRefundNeeded = false) {
    const formData = new FormData()
    if (file) {
      formData.append('file', file)
    }
    formData.append('noRefundNeeded', noRefundNeeded)
    return fileApi.post(`/enrollments/${id}/refund`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 获取所有报名数据（用于导出，不分页）
  fetchAllEnrollments(params = {}) {
    const query = new URLSearchParams()
    const { courseId, status, keyword } = params
    // 设置一个很大的size来获取所有数据
    query.append('page', 0)
    query.append('size', 10000)
    if (courseId) query.append('courseId', courseId)
    if (status) query.append('status', status)
    if (keyword) query.append('keyword', keyword)
    return api.get(`/enrollments?${query.toString()}`)
  }
}

